/* KUCHYNĚ DVOŘÁK — prémiové efekty (jiskry z kovárny, odhalení, průběh).
   Jen vizuál: nemění texty ani data obchodu. */
(function () {
  'use strict';
  var d = document, w = window, root = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = !!(w.Shopify && w.Shopify.designMode);

  /* ---------- Barra de progreso + cabecera al hacer scroll ---------- */
  function initProgress() {
    var bar = d.createElement('div');
    bar.className = 'fx-progress';
    bar.setAttribute('aria-hidden', 'true');
    d.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = root.scrollHeight - w.innerHeight;
      var p = h > 0 ? Math.min(1, w.scrollY / h) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
      root.classList.toggle('fx-scrolled', w.scrollY > 40);
      ticking = false;
    }
    w.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; w.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Revelado de secciones ---------- */
  function initReveal() {
    if (reduce || inEditor || !('IntersectionObserver' in w)) return;
    var sections = d.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fx-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    root.classList.add('fx-ready');
    sections.forEach(function (s, i) {
      if (i === 0) return; // el hero se ve siempre al instante
      var r = s.getBoundingClientRect();
      if (r.top < w.innerHeight) return; // ya visible al cargar
      s.classList.add('fx-reveal');
      io.observe(s);
    });
    d.querySelectorAll('.text-with-icons').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < w.innerHeight) return;
      var grid = el.querySelector('.grid') || el;
      grid.classList.add('fx-stagger');
      Array.prototype.forEach.call(grid.children, function (c, i) { c.style.transitionDelay = (i * 0.12) + 's'; });
      io.observe(grid);
    });
    // Seguridad: nunca dejar contenido oculto
    setTimeout(function () {
      d.querySelectorAll('.fx-reveal, .fx-stagger').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < w.innerHeight * 1.2) el.classList.add('fx-in');
      });
    }, 2500);
  }

  /* ---------- Brasas de forja sobre el hero ---------- */
  function Embers(host) {
    var c = d.createElement('canvas');
    c.className = 'fx-embers';
    c.setAttribute('aria-hidden', 'true');
    host.appendChild(c);
    var ctx = c.getContext('2d');
    var dpr = Math.min(w.devicePixelRatio || 1, 2);
    var W = 0, H = 0, parts = [], running = false, raf = 0, last = 0;
    var mobile = w.innerWidth < 768;
    var COUNT = mobile ? 26 : 60;

    function size() {
      var r = host.getBoundingClientRect();
      W = r.width; H = r.height;
      c.width = W * dpr; c.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(p, initial) {
      p.x = Math.random() * W;
      p.y = initial ? Math.random() * H : H + 10;
      p.r = Math.random() * 1.8 + 0.5;
      p.vy = -(Math.random() * 0.55 + 0.25);
      p.vx = (Math.random() - 0.5) * 0.25;
      p.life = 0;
      p.max = Math.random() * 380 + 260;
      p.wob = Math.random() * Math.PI * 2;
      p.hue = 22 + Math.random() * 22; // naranja -> oro
      return p;
    }
    for (var i = 0; i < COUNT; i++) parts.push(spawn({}, true));

    function frame(t) {
      var dt = Math.min(3, (t - last) / 16.67 || 1);
      last = t;
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.life += dt;
        p.wob += 0.03 * dt;
        p.x += (p.vx + Math.sin(p.wob) * 0.18) * dt;
        p.y += p.vy * dt;
        var k = p.life / p.max;
        if (k >= 1 || p.y < -10) { spawn(p, false); continue; }
        var a = Math.sin(Math.PI * k) * 0.9;
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 5);
        g.addColorStop(0, 'hsla(' + (p.hue + 18) + ',100%,78%,' + a + ')');
        g.addColorStop(0.35, 'hsla(' + p.hue + ',95%,55%,' + (a * 0.55) + ')');
        g.addColorStop(1, 'hsla(' + p.hue + ',90%,45%,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 5, 0, Math.PI * 2);
        ctx.fill();
      }
      if (running) raf = w.requestAnimationFrame(frame);
    }
    function start() { if (!running) { running = true; last = performance.now(); raf = w.requestAnimationFrame(frame); } }
    function stop() { running = false; w.cancelAnimationFrame(raf); }

    size();
    w.addEventListener('resize', function () { size(); }, { passive: true });
    if ('IntersectionObserver' in w) {
      new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }, { threshold: 0 }).observe(host);
    } else { start(); }
    d.addEventListener('visibilitychange', function () { d.hidden ? stop() : start(); });
  }

  function initEmbers() {
    if (reduce) return;
    var hosts = [];
    var hero = d.querySelector('#MainContent .slideshow-wrapper, #MainContent .hero');
    if (hero) hosts.push(hero);
    d.querySelectorAll('#MainContent .background-media-text').forEach(function (el) { hosts.push(el); });
    hosts.forEach(function (h) {
      if (h.querySelector('.fx-embers')) return;
      if (getComputedStyle(h).position === 'static') h.style.position = 'relative';
      Embers(h);
    });
  }


  /* ---------- Lightbox pro fotky zákazníků ---------- */
  function initLightbox() {
    d.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-kd-zoom]');
      if (btn) {
        var tpl = btn.querySelector('template');
        var sec = btn.closest('.kd-ugc');
        var dlg = sec && sec.querySelector('.kd-lightbox');
        if (!tpl || !dlg || !dlg.showModal) return;
        var img = dlg.querySelector('img');
        img.src = tpl.innerHTML.trim().replace(/&amp;/g, '&');
        var thumb = btn.querySelector('img');
        img.alt = thumb ? thumb.alt : '';
        dlg.showModal();
        return;
      }
      var dl = e.target.closest && e.target.closest('.kd-lightbox');
      if (dl && (e.target === dl || e.target.classList.contains('kd-lightbox__close'))) dl.close();
    });
  }


  /* ---------- Karusel fotek zákazníků ---------- */
  function initCarousels(scope) {
    (scope || d).querySelectorAll('.kd-ugc').forEach(function (sec) {
      if (sec.__kdCar) return; sec.__kdCar = true;
      var track = sec.querySelector('[data-kd-track]');
      var prev = sec.querySelector('[data-kd-prev]');
      var next = sec.querySelector('[data-kd-next]');
      var bar = sec.querySelector('[data-kd-bar]');
      if (!track) return;
      function step() {
        var s = track.querySelector('.kd-ugc__slide');
        if (!s) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var per = Math.max(1, Math.floor(track.clientWidth / (s.offsetWidth + gap)) - 1);
        return per * (s.offsetWidth + gap);
      }
      var intro = sec.querySelector('.kd-ugc__intro');
      function align() {
        if (!intro) return;
        var left = Math.max(16, Math.round(intro.getBoundingClientRect().left - sec.getBoundingClientRect().left));
        track.style.paddingLeft = left + 'px';
        track.style.paddingRight = left + 'px';
        track.style.scrollPaddingLeft = left + 'px';
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
        if (bar) {
          var vis = max > 0 ? track.clientWidth / track.scrollWidth : 1;
          bar.style.width = (vis * 100) + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (x / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step() }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step() }); }
      });
      track.addEventListener('scroll', function () { w.requestAnimationFrame(update); }, { passive: true });
      w.addEventListener('resize', function () { align(); update(); }, { passive: true });
      align(); update();
    });
  }

  function init() {
    try { initProgress(); } catch (e) {}
    try { initReveal(); } catch (e) {}
    try { initLightbox(); } catch (e) {}
    try { initCarousels(); } catch (e) {}
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();

  // Editor de temas: re-aplicar al recargar secciones
  d.addEventListener('shopify:section:load', function (e) { try { initCarousels(e.target); } catch (err) {} });
})();
